import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const CmTrophy = () => {
  const navigate = useNavigate();
  useEffect(() => { navigate('/cm-trophy/dashboard'); }, [navigate]);
  return null;
};

export default CmTrophy;
